import { FormItem, SurveyFormStyle, TextAnswerFormat } from "../../../types/Survey";

const allowedAnswerFormats = ["NumericAnswerFormat", "ValuePickerAnswerFormat", "DateAnswerFormat", "TimeOfDayAnswerFormat", "FileAnswerFormat", "PhoneAnswerFormat", "EmailAnswerFormat", "PostalCodeAnswerFormat", "DateOfBirthAnswerFormat"];
export function canCustomizeTextPosition(formItem: FormItem): boolean {
    if (formItem.answerFormat?.type === "TextAnswerFormat") {
        return !(formItem.answerFormat as TextAnswerFormat).multipleLines;
    }

    return !!formItem.answerFormat && allowedAnswerFormats.includes(formItem.answerFormat.type);
}

export function sectionCanBeInHorizontalLayout(section: FormItem[]) {
    if (section.length != 1) { return false; }
    if (!section[0].allowHorizontalLayout) { return false; }
    if (!section[0].minimumWidth) { return false; }
    return canBeInHorizontalLayout(section[0]);
}

export function canBeInHorizontalLayout(formItem: FormItem): boolean {
    return formItem.textPosition === "top" && canCustomizeTextPosition(formItem);
}

export function isMultilineFormItem(formItem: FormItem, variant?: SurveyFormStyle) {
    if (!formItem.answerFormat) {
        return true;
    }
    if (formItem.textPosition == "left") {
        return false;
    }
    return (formItem.text?.length || 0) > 19 ||
        (formItem.placeholder?.length || 0) > 19 ||
        formItem.answerFormat.type == "BooleanAnswerFormat" ||
        formItem.answerFormat.type == "TextChoiceAnswerFormat" ||
        formItem.answerFormat.type == "ScaleAnswerFormat" ||
        formItem.answerFormat.type == "ContinuousScaleAnswerFormat" ||
        (formItem.answerFormat.type == "TextAnswerFormat" && (formItem.answerFormat as TextAnswerFormat).multipleLines) ||
        (variant === "v2" && formItem.textPosition === "top");
}